/* DJIZA recommendations: section-safe asynchronous loading with scroll-snap arrows. */
(() => {
  function init(root) {
    if (!root || root.dataset.djizaInitialized === 'true') return;
    root.dataset.djizaInitialized = 'true';
    if (root.dataset.preloaded === 'true') return;
    const url = root.dataset.recommendationsUrl;
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
        return response.text();
      })
      .then(html => {
        if (!root.isConnected) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const result = doc.getElementById(root.id);
        const content = result && result.querySelector('.djiza-recommendations__content');
        if (content && content.querySelector('.djiza-products__card')) {
          root.replaceChildren(content);
          root.hidden = false;
        } else {
          root.hidden = true;
        }
      })
      .catch(error => { console.warn('DJIZA recommendations:', error); });
  }

  function start(scope = document) {
    scope.querySelectorAll('[data-djiza-recommendations]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  } else { start(); }

  document.addEventListener('shopify:section:load', event => start(event.target));

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-djiza-scroll]');
    if (!button) return;
    const section = button.closest('.djiza-recommendations');
    const track = section && section.querySelector('.djiza-products--slider');
    const card = track && track.querySelector('.djiza-products__card');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const increment = card.getBoundingClientRect().width + gap;
    track.scrollBy({ left: (button.dataset.djizaScroll === 'next' ? 1 : -1) * increment,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
})();
